import { ReactElement, useState } from 'react'
import type { DefaultMemberCrossSectionsDTO } from '@api/fastAPI.schemas'
import { LoadingIndicator } from '@ui/feedback'
import DefaultMemberCrossSectionsPanel from './DefaultMemberCrossSectionsPanel'

interface Props {
  values?: DefaultMemberCrossSectionsDTO
  isLoading: boolean
  readOnly?: boolean
  onSave: (body: DefaultMemberCrossSectionsDTO) => Promise<unknown>
}

const DefaultMemberCrossSectionsEditor = ({
  values,
  isLoading,
  readOnly = false,
  onSave,
}: Props): ReactElement | null => {
  const [isSaving, setIsSaving] = useState(false)

  if (isLoading) {
    return <LoadingIndicator />
  }
  if (!values) {
    return null
  }

  return (
    <DefaultMemberCrossSectionsPanel
      values={values}
      readOnly={readOnly}
      isSaving={isSaving}
      onSave={body => {
        setIsSaving(true)
        onSave(body)
          .catch(() => undefined)
          .finally(() => {
            setIsSaving(false)
          })
      }}
    />
  )
}

export default DefaultMemberCrossSectionsEditor
